const sendEmailDraftInvoiceCreated = async (
  devis_id,
  token,

  prefix
) => {
  // Define the endpoint URL
  const url = prefix + `devis/${devis_id}/draft-created-particulier`;

  // Define the request body
  const body = {};

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body), // Encode the body as JSON
    });

    // Check if the request was successful
    if (response.ok) {
      return "Email sent successfully";
    } else {
      console.error(`Failed to send email: ${response.status}`);
      return `Failed to send email: ${response.status}`;
    }
  } catch (error) {
    console.error(`Exception occurred: ${error.message}`);
    return `Exception occurred: ${error.message}`;
  }
};

export default sendEmailDraftInvoiceCreated;
